<p-contextMenu #contextMenu [model]="cardOptions" appendTo="body"></p-contextMenu>
<p-menu #popupMenu [popup]="true" [model]="cardOptions" appendTo="body"></p-menu>

<div class="board-container">
  <ng-container *ngIf="fleetsGrouped$ | async as groups">
    <!-- Empty State -->
    <div *ngIf="groups.length == 0" class="empty-validations-container">
      <div class="empty-icon-box">
        <i class="pi pi-search"></i>
      </div>
      <h5>No se encontraron validaciones</h5>
      <p>No se encontraron grupos que coincidan con la búsqueda.</p>
    </div>

    <!-- Time Grouping (Hoy / Histórico) -->
    <div *ngFor="let group of groups" class="time-group-block">
      <div class="time-group-header">
        <div class="time-header-left">
          <h2 class="time-group-title">{{ group.label }}</h2>
        </div>
        <span class="group-count-badge">
          {{ group.groups.length }} {{ group.groups.length === 1 ? 'categoría' : 'categorías' }}
        </span>
      </div>

      <div class="time-group-content">
        <!-- Type Grouping (Interno / Externo) -->
        <div *ngFor="let fleet of group.groups" class="type-section" [ngClass]="'type-' + (fleet.type | lowercase)">
          <div class="type-section-header">
            <div class="type-header-title">

              <span class="type-name-text">{{ getFleetType(fleet.type) }}</span>
            </div>
            <span class="type-count-badge">
              {{ fleet.items.length }} {{ fleet.items.length === 1 ? 'checklist' : 'checklists' }}
            </span>
          </div>

          <div class="cards-stack">
            <ng-container *ngFor="let checklist of fleet.items">
              <div class="card-item-wrapper" (contextmenu)="openContextMenu($event, checklist)" [class.past-card]="!group.isToday">
                <app-fleet-checklist-card
                  (showOptions)="openPopupMenu($event)"
                  [summary]="checklist">
                </app-fleet-checklist-card>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
